<div 
  class="custom-toggle"
  [class.disabled]="disabled"
  [class.checked]="checked"
  [class.small]="size === 'small'"
  [class.medium]="size === 'medium'"
  [class.large]="size === 'large'"
  (click)="onToggle()"
  [attr.id]="id"
  role="switch"
  [attr.aria-checked]="checked"
  [attr.aria-disabled]="disabled"
  tabindex="0"
  (keydown.enter)="onToggle()"
  (keydown.space)="onToggle()"
>
  <div class="toggle-track">
    <div class="toggle-slider"></div>
  </div>
</div>
